import React from 'react';
import { func } from 'prop-types';
import { Button, UncontrolledTooltip } from 'reactstrap';
import Icon from '../Icon/Icon';
import { FMessage } from '../../hoc/IntlComponents';

const propTypes = {
  onRefresh: func.isRequired,
};

const StatisticRefreshButton = ({ onRefresh }) => {
  return (
    <>
      <button
        id="statistics-filters-addons-refresh"
        type="button"
        className="statistics-mini-button statistics-mini-button--refresh"
        onClick={onRefresh}
      >
        <Icon type="refresh" />
      </button>
      <UncontrolledTooltip placemenyt="top" target="statistics-filters-addons-refresh">
        <FMessage id="statistics.filters.addons.refresh.tooltip" />
      </UncontrolledTooltip>
    </>
  );
};

StatisticRefreshButton.propTypes = propTypes;

export default StatisticRefreshButton;
